export function initIframeResize() {
  if (window.parent === window) {
    return;
  }

  const sendHeight = () => {
    const height = document.body?.scrollHeight ?? document.documentElement?.scrollHeight ?? 0;
    window.parent.postMessage({
      type: 'tlf-iframe-resize',
      height: height,
    }, '*');
  };

  window.addEventListener('load', sendHeight);
  window.addEventListener('resize', sendHeight);

  const startObserver = () => {
    if (!document.body) {
      return;
    }

    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    sendHeight();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, {once: true});
  } else {
    startObserver();
  }

  window.setInterval(sendHeight, 500);
}
